import { render, staticRenderFns } from "./CdbCustomerMergePage.vue?vue&type=template&id=24c2f9fe&scoped=true&"
import script from "./CdbCustomerMergePage.vue?vue&type=script&lang=js&"
export * from "./CdbCustomerMergePage.vue?vue&type=script&lang=js&"
import style0 from "./CdbCustomerMergePage.vue?vue&type=style&index=0&id=24c2f9fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c2f9fe",
  null
  
)

export default component.exports